import React, { useContext } from "react";
import { HomepageContext } from "@/components/header/ConnectedHeader";
import {
  SectionTitle,
  RichTextContent,
  SectionContainer,
  CrossedOutDustbinSymbol,
  Accordion,
} from "@/components";
import { i18n } from "./WasteBatterySection.i18n";
import styles from "./WasteBatterySection.module.css";

export const WasteBatterySection: React.FC = () => {
  const { language } = useContext(HomepageContext);

  // Only render for Czech and English languages
  if (language !== "cs" && language !== "en") {
    return null;
  }

  const currentLang = (language || "cs") as keyof typeof i18n.sectionTitle;

  return (
    <SectionContainer id="waste-battery-takeback" className={styles.section}>
      <SectionTitle title={i18n.sectionTitle[currentLang]} />
      <div className={styles.content}>
        <div className={styles.textContent}>
          <RichTextContent
            content={i18n.introText[currentLang]}
            className={styles.description}
          />

          <div className={styles.symbolWrapper}>
            <CrossedOutDustbinSymbol
              className={styles.symbolIcon}
              aria-label={i18n.sectionTitle[currentLang]}
            />
          </div>

          {/* Move subsection to left column, below symbolWrapper */}
          <div className={styles.subsection}>
            <h3 className={styles.subheading}>{i18n.whyRecycleHeading[currentLang]}</h3>
            <RichTextContent
              content={i18n.whyRecycleText[currentLang]}
              className={styles.description}
            />
          </div>
        </div>

        <div className={styles.bannerColumn}>
          {/* Move banner to right column */}
          <div className={styles.banner}>
            <h3 className={styles.bannerTitle}>{i18n.howToDisposeHeading[currentLang]}</h3>
            <ul className={styles.bannerList}>
              {i18n.howToDisposeList[currentLang].map((item, index) => (
                <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
              ))}
            </ul>
          </div>

          {/* Keep the Accordion section in the right column */}
          <div className={styles.batteryTypesSection}>
            <h3 className={styles.subheading}>{i18n.batteryTypesHeading[currentLang]}</h3>
            <Accordion
              items={i18n.batteryTypes[currentLang]}
            />
          </div>
        </div>
      </div>
    </SectionContainer>
  );
};
